import { cn } from "@/lib/utils";
import { Infinity as InfinityIcon, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useCurrency } from "@/context/CurrencyContext";

export const PlanSelector = ({ plans = [], value, onChange }) => {
  const { t } = useTranslation();
  const { format } = useCurrency();
  return (
  <div className="grid grid-cols-1 gap-2" data-testid="plan-selector">
    {plans.map((p) => {
      const selected = value === p.code;
      const eternal = p.hours == null;
      return (
        <button
          type="button"
          key={p.code}
          onClick={() => onChange(p.code)}
          data-testid={`plan-${p.code}`}
          className={cn(
            "flex items-center justify-between rounded-2xl border px-4 py-3 text-left transition-colors",
            selected
              ? "border-sky-400 bg-sky-400/10"
              : "border-white/10 bg-card/40 hover:border-white/25"
          )}
        >
          <div className="flex items-center gap-3">
            <span
              className={cn(
                "flex h-5 w-5 items-center justify-center rounded-full border",
                selected ? "border-sky-400 bg-sky-400 text-black" : "border-white/25"
              )}
            >
              {selected && <Check size={13} />}
            </span>
            <span className="flex items-center gap-1.5 font-medium">
              {eternal && <InfinityIcon size={15} className="text-sky-400" />}
              {p.i18n === false ? p.label : t(`plans.${p.code}`, p.label)}
            </span>
          </div>
          <span className={cn("font-semibold tabular-nums", selected ? "text-sky-300" : "text-foreground/80")}>
            {format(p.price_cents)}
          </span>
        </button>
      );
    })}
  </div>
  );
};
